import React from 'react';
export function Footer() {
  return <footer className="bg-black dark:bg-[#090D1A] text-white py-16 border-t border-transparent dark:border-white/10 transition-colors duration-300" data-id="element-139" data-mp="32wd2qgad7ltj">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-140" data-mp="32oe3e4sjqrfe">
        <div className="flex flex-col md:flex-row justify-between items-center gap-12" data-id="element-141" data-mp="32lrm3dfusxjz">
          <div className="flex items-center" data-id="element-142" data-mp="36ppivhhphw9v">
            <img src="https://cdn.magicpatterns.com/uploads/wARv7Md6wddGeKdpXuv8BA/gemini-svg_(2).svg" alt="Effy Mobile" className="h-[68px] w-auto object-contain bg-white p-1.5 rounded-lg" data-id="element-143" data-mp="3ueil1vox90cx" />
          </div>

          <div className="flex gap-8 text-sm font-medium text-gray-500" data-id="element-144" data-mp="3lf598wdbrzp1">
            <a href="#" className="hover:text-white transition-colors" data-id="element-145" data-mp="3qdf393nbcu92">
              Terms
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-146" data-mp="29zgkbzgigqll">
              Privacy
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-147" data-mp="2eyt8qon165qa">
              Security
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-148" data-mp="3l8qy89n2utu3">
              Coverage
            </a>
          </div>

          <p className="text-xs text-gray-600 font-mono" data-id="element-149" data-mp="3gc0gzizjds73">
            © 2026 EFFY MOBILE INFRASTRUCTURE. ALL RIGHTS RESERVED.
          </p>
        </div>
      </div>
    </footer>;
}